// src/components

export const searchMasterCache = {
  maritalStatus: null,
  height: null,
  country: null,
  domain: null,
  education: null,
  occupation: null,
  religion: null,
  income: null,
};
